

import React, { memo } from 'react';
import { Button, Text } from '../../../../ui-kit';
import '../../styles/_new-output.scss';






function NewOutput({ onClick, disabled }) {
  return (
    <Button className="new-output" disabled={disabled} type="TERTIARY" prefix="addfat" onClick={onClick}>
      <Text heading5>Additional Iteration</Text>
    </Button>);

}

export default memo(NewOutput);